import React, { lazy, Suspense, useEffect, useMemo } from "react";
import { _authState } from "../store/auth/_authState";
import { SplashScreen } from "@berriesflow/core";
import useAuth from "../store/auth/useAuth";
import { useAtomValue } from "jotai";

// import Routers
const RouterNoLogin = lazy(() => import("./routerNolLogin"));
const ProducerRouter = lazy(() => import("./producerRouter"));

export default function App() {
    const { loadProfile } = useAuth();
    const { init, isLogged } = useAtomValue(_authState);

    const myRouter = useMemo(() => {
        if (isLogged) return <ProducerRouter />;
        return <RouterNoLogin />;
    }, [isLogged]);

    // --- Effects ---
    useEffect(() => {
        loadProfile();
    }, [loadProfile]);

    return <>{init ? <Suspense fallback={<SplashScreen />}>{myRouter}</Suspense> : <SplashScreen />}</>;
}
